import { arrayOf, shape, string } from "prop-types";

export default arrayOf(
  shape({
    value: string,
    label: string,
    fieldValues: arrayOf(string)
  })
);
